import { translations } from '@janus.team/janus-particles';
import React from 'react';
import { AccountSelector } from 'account-selector';
import { SeveritySelector } from './severity-selector';
import { useCustomerAccountsQuery } from 'api/cms';
import * as loading from 'loading';
import * as errors from 'error';
import { MonitoringSelector } from './monitoring-selector/index.js';
import { DataSourceSelector } from './data-source-selector';
import { useLocation } from 'react-router-dom';

const Header = () => {
  const t = translations.useT();
  return (
    <div className="container-fluid container-xxl">
      <header className="my-8">
        <h1>{t('Webhooks')}</h1>
      </header>
    </div>
  );
};

export const Webhooks = () => {
  const customerAccountsQuery = useCustomerAccountsQuery();
  const t = translations.useT();
  const version = /tiles/.test(`${useLocation()?.search}`) ? 'tiles' : 'dropdown';
  return customerAccountsQuery.isError ? (<errors.FullPage code={500} message={t('Error Loading Accounts')}/>) : (
    <main>
      <Header />
      {(customerAccountsQuery.isFetched) ? (
        <>
          <AccountSelector />
          {(version === 'tiles') && (<DataSourceSelector />)}
          {(version === 'dropdown') && (<MonitoringSelector />)}
          <SeveritySelector />
        </>
      ) : (
        <loading.Section />
      )}
    </main>
  );
};
